<template>
  <div>
    <b-card
      title="Görsel"
      no-body
    >
      <b-img
        v-if="itemData.image"
        :src="imageUrl + '/media/about/' + itemData.image"
        thumbnail
        center
      />
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          @click="setModal('about_items')"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
        <b-button
          v-if="itemData.image"
          variant="danger"
          class="ml-2"
          @click="removePhoto"
        >
          <FeatherIcon icon="TrashIcon" />
          Görseli Kaldır
        </b-button>
      </div>
    </b-card>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      :width-size="570"
      :resize="true"
      @uploadImage="setUploadImage"
    />
  </div>
</template>

<script>
import { BButton, BCard, BImg } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'

export default {
  name: 'ImageCard',
  components: {
    CropperImage, BCard, BButton, BImg,
  },
  data() {
    return {
      imageUrl: this.$store.state.app.baseURL,
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['aboutItems/dataItem']
    },
  },
  methods: {
    setModal(type) {
      if (type === 'about_items') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'aboutItems-image.jpg',
          folder: 'about',
          ratio: 800 / 600,
          type: 'about_items',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'about_items') {
        this.itemData.image = item.image
        this.itemData.thumb = item.thumb
      }
      this.cropperSettings.modalStatus = false
    },
    removePhoto() {
      if (this.itemData.image) {
        this.itemData.image = ''
        this.itemData.thumb = ''
      }
    },
  },
}
</script>
